// eslint-disable-next-line import/named
import { takeLatest, takeEvery, all } from 'redux-saga/effects'

import { OrderTypes } from '../reducers/orderReducer'
import { RestaurantTypes } from '../reducers/restaurantReducer'
import { ItemTypes } from '../reducers/itemReducer'
import { DelivereeTypes } from '../reducers/delivereeReducer'
import { MenuTypes } from '../reducers/menuReducer'
import { AuthTypes } from '../reducers/authReducer'
import { TagTypes } from '../reducers/tagReducer'
import { DriverTypes } from '../reducers/driverReducer'
import { PartnerTypes } from '../reducers/partnerReducer'
import { SponsorTypes } from '../reducers/sponsorReducer'
import { PopularTypes } from '../reducers/popularReducer'
import { RolePermissionTypes } from '../reducers/rolePermissionReducer'
import { UserTypes } from '../reducers/userReducer'
import { DashboardTypes } from '../reducers/dashboardReducer'
import { RecentListTypes } from '../reducers/recentListReducer'
import { ItemOptionTypes } from '../reducers/itemOptionReducer'
import { DriverSegmentTypes } from '../reducers/driverSegmentReducer'
import { DynamicFeeTypes } from '../reducers/dynamicFeeReducer'
import { MerchantSettlementTypes } from '../reducers/merchantSettlementReducer'
import { MapViewTypes } from '../reducers/mapViewReducer'
import { ExpressTypes } from '../reducers/expressReducer'
import { PromotionTypes } from '../reducers/promotionReducer'
import { PickUpPromotionTypes } from '../reducers/pickUpPromotionReducer'
import { SpecialDealTypes } from '../reducers/specialDealReducer'
import { RegionTypes } from '../reducers/regionReducer'
import { UnavailableItemTypes } from '../reducers/unavailableItemReducer'
import { DriverIncentiveTypes } from '../reducers/driverIncentiveReducer'
import { CashOutTypes } from '../reducers/cashOutReducer'
import { AppInboxTypes } from '../reducers/appInboxReducer'
import { HasuraOrderTypes } from '../reducers/hasuraOrderReducer'
import { HasuraItemTypes } from '../reducers/hasuraItemReducer'
import { HasuraSearchItemTypes } from '../reducers/hasuraSearchItemReducer'
import { HasuraDataValidationTypes } from '../reducers/hasuraDataValidationReducer'
import { DelivereeReportTypes } from '../reducers/delivereeReportReducer'
import { OperatorReportTypes } from '../reducers/operatorReportReducer'
import { CartBasedPromotionTypes } from '../reducers/cartBasedPromotionReducer'
import { DeliveryFeeOfferTypes } from '../reducers/deliveryFeeOfferReducer'
import { MerchandiseCodeTypes } from '../reducers/merchandiseCodeReducer'
import { DriverTransactionTypes } from '../reducers/driverTransactionReducer'
import { ItemSyncTypes } from '../reducers/itemSyncReducer'
import { DelivererOrderTypes } from '../reducers/delivererOrderReducer'
import { LocationReportTypes } from '../reducers/locationReportReducer'
import { CrossSellItemTypes } from '../reducers/crossSellItemReducer'
import { AppCustomizationTypes } from '../reducers/appCustomizationReducer'
import { MerchantCloseRequestTypes } from '../reducers/merchantCloseRequestReducer'
import { ServiceAvailabilityTypes } from '../reducers/serviceAvailabilityReducer'
import { FreeCheckoutTypes } from '../reducers/freeCheckoutReducer'
import { QuantityPromotionTypes } from '../reducers/quantityPromotionReducer'
import {LuckyDrawWinnerTypes} from '../reducers/luckyDrawWinnerReducer'

import { syncTodayOrders, syncDriverPendingOrders } from './orderSaga'
import {
  fetchRestaurant,
  fetchRestaurants,
  deleteBranch,
  saveBranch,
  saveRestaurant,
  getBranchOrders,
} from './restaurantSaga'
import { fetchStoreItems, saveItemArrangement, saveItem, deleteItem } from './itemSaga'
import { savePartner, fetchPartner, fetchPartners } from './partnerSaga'
import {
  getAnalyticOrders,
  deleteDriver,
  saveDriver,
  syncDrivers,
  toggleDriverOnline,
  fetchTimeSlot,
  updateTimeSlot,
  getNonVerifyTransactions,
} from './driverSaga'
import { fetchUsers, getDeliveree, getDelivereeReport } from './delivereeSaga'
import { getOperatorReport } from './operatorReportSaga'
import { fetchSelectedCategories, fetchMenus } from './menuSaga'
import { login, handleAuthSuccess, logout } from './authSaga'
import { fetchTags } from './tagSaga'
import { getSponsors } from './sponsorSaga'
import { getPopularList } from './popularSaga'
import { getAllRolesPermissions, getAllModules, trackCurrentUserRole } from './rolePermissionSaga'
import { getAllUsers } from './userSaga'
import { getOrderByDate, getCustomersByDate, getPayingCustomers, getExpressOrders } from './dashboardSaga'
import { handleNotification } from './notificationSaga'
import { getRecentLists } from './recentListSaga'
import { getItemOptions } from './itemOptionSaga'

import { saveDriverSegment, syncDriverSegments, deleteDriverSegment } from './driverSegmentSaga'
import { saveDynamicFee, syncDynamicFees, deleteFee } from './dynamicFeeSaga'
import { getMerchantNote } from './merchantSagas'
import { syncDriversBySegment } from './driverIncentiveSaga'
import { toggleMapView } from './mapViewSaga'
import { getHistoryCashOuts, syncPendingCashOuts, confirmCashOut, cancelCashOut } from './cashOutSaga'
import { syncAppInboxes, deleteAppInbox } from './appInboxSaga'
import {
  fetchPayLaterOrders,
  saveMerchantSettlement,
  syncMerchantSettlements,
  paidMerchant,
} from './merchantSettlementSaga'
import { syncExpress, getCodReport, getExpressOrdersReport } from './expressSaga'
import { getPromotions, deletePromotion } from './promotionSaga'
import { getPickUpPromotions, deletePickUpPromotion } from './pickUpPromotionSaga'
import { getSpecialDeals, deleteSpecialDeal, syncSpecialDeal } from './specialDealSaga'
import { getRegions, getDistricts } from './regionSaga'
import { getUnavailableItem } from './unavailableItemSaga'
import {
  fetchOrders,
  getSaleReports,
  getRefundOrders,
  getPromoCodeOrders,
  getPromotionExpense,
  getMerchantCategories,
  getLocationReport,
} from './hasuraOrderSaga'
import { fetchItems } from './hasuraItemSaga'
import { searchItems, updateAlterItems } from './hasuraSearchItemSaga'
import { getItems, getOrders, reuploadOrders } from './hasuraDataValidationSaga'
import {
  getCartBasedPromotions,
  saveCartBasedPromotion,
  deleteCartBasedPromotion,
} from './cartBasedPromotionSaga'
import { getDeliveryFeeOffers, deleteDeliveryFeeOffer, saveDeliveryFeeOffer } from './deliveryFeeOfferSaga'
import { saveMerchandiseCode, getMerchandiseCodes } from './merchandiseCodeSaga'
import { getDriverTransactions } from './driverTransactionSaga'
import { getItemSync, syncMerchantItems, setLastUpdate } from './itemSyncSaga'
import { getDelivererOrders } from './delivererOrdersSaga'
import { getCrossSellItems } from './crossSellItemSaga'
import { getCustomization } from './appCustomizationSaga'
import { syncPendingRequests } from './merchantCloseRequestSaga'

import { getServiceAvailability } from './serviceAvailabilitySaga'
import { syncFreeCheckoutPromotions } from './freeCheckoutSaga'

import { getQuantityPromotions, deleteQuantityPromotion } from './quantityPromotionSaga'
import {getLuckyDrawWinners} from './luckyDrawWinnerSaga'

export default function* root() {
  yield all([
    takeLatest(OrderTypes.SYNC_TODAY_ORDERS, syncTodayOrders),
    takeLatest(OrderTypes.SYNC_DRIVER_PENDING_ORDERS, syncDriverPendingOrders),

    takeLatest(RestaurantTypes.FETCH_RESTAURANTS_REQUEST, fetchRestaurants),
    takeLatest(RestaurantTypes.SAVE_RESTAURANT_REQUEST, saveRestaurant),
    takeEvery(RestaurantTypes.FETCH_RESTAURANT_REQUEST, fetchRestaurant),
    takeEvery(RestaurantTypes.DELETE_BRANCH, deleteBranch),
    takeEvery(RestaurantTypes.SAVE_BRANCH, saveBranch),
    takeLatest(RestaurantTypes.GET_BRANCH_ORDERS, getBranchOrders),

    takeLatest(ItemTypes.FETCH_ITEMS_BY_RESTAURANT, fetchStoreItems),
    takeLatest(ItemTypes.SAVE_ARRANGEMENT, saveItemArrangement),
    takeEvery(ItemTypes.SAVE_ITEM, saveItem),
    takeEvery(ItemTypes.DELETE_ITEM, deleteItem),

    takeLatest(ItemOptionTypes.GET_ITEM_OPTIONS, getItemOptions),

    takeEvery(DelivereeTypes.FETCH_DELIVEREES_REQUEST, fetchUsers),
    takeLatest(DelivereeTypes.GET_DELIVEREE, getDeliveree),
    takeLatest(DelivereeReportTypes.GET_DELIVEREE_REPORT, getDelivereeReport),

    takeLatest(OperatorReportTypes.GET_OPERATOR_REPORT, getOperatorReport),

    takeLatest(MenuTypes.FETCH_MENUS_REQUEST, fetchMenus),
    takeLatest(MenuTypes.FETCH_SELECTED_CATEGORIES_REQUEST, fetchSelectedCategories),
    takeLatest(TagTypes.FETCH_TAGS_REQUEST, fetchTags),

    takeLatest(AuthTypes.LOGIN, login),
    takeLatest(AuthTypes.HANDLE_AUTH_SUCCESS, handleAuthSuccess),
    takeLatest(AuthTypes.LOGOUT, logout),

    takeLatest(DriverTypes.SYNC_DRIVERS, syncDrivers),
    takeLatest(DriverTypes.SAVE_DRIVER, saveDriver),
    takeEvery(DriverTypes.DELETE_DRIVER, deleteDriver),
    takeLatest(DriverTypes.GET_ANALYTIC_ORDERS, getAnalyticOrders),
    takeEvery(DriverTypes.TOGGLE_DRIVER_ONLINE, toggleDriverOnline),
    takeLatest(DriverTypes.FETCH_TIME_SLOT, fetchTimeSlot),
    takeEvery(DriverTypes.UPDATE_TIME_SLOT, updateTimeSlot),
    takeEvery(DriverTypes.GET_NON_VERIFY_TRANSACTIONS, getNonVerifyTransactions),

    takeLatest(DriverSegmentTypes.SAVE_DRIVER_SEGMENT, saveDriverSegment),
    takeLatest(DriverSegmentTypes.SYNC_DRIVER_SEGMENTS, syncDriverSegments),
    takeEvery(DriverSegmentTypes.DELETE_DRIVER_SEGMENT, deleteDriverSegment),

    takeLatest(DynamicFeeTypes.SAVE_DYNAMIC_FEE, saveDynamicFee),
    takeLatest(DynamicFeeTypes.SYNC_DYNAMIC_FEES, syncDynamicFees),
    takeEvery(DynamicFeeTypes.DELETE_DYNAMIC_FEE, deleteFee),
    takeLatest(DriverIncentiveTypes.SYNC_DRIVERS_BY_SEGMENT, syncDriversBySegment),

    takeLatest(PartnerTypes.SAVE_PARTNER_REQUEST, savePartner),
    takeLatest(PartnerTypes.FETCH_PARTNERS_REQUEST, fetchPartners),
    takeEvery(PartnerTypes.FETCH_PARTNER_REQUEST, fetchPartner),

    takeLatest(SponsorTypes.GET_SPONSORS, getSponsors),
    takeLatest(PopularTypes.GET_POPULAR_LIST, getPopularList),
    takeLatest(RecentListTypes.GET_RECENT_LISTS, getRecentLists),

    takeLatest(UserTypes.GET_ALL_USERS, getAllUsers),

    takeLatest(DashboardTypes.GET_ORDER_BY_DATE, getOrderByDate),
    takeLatest(DashboardTypes.GET_PAYING_CUSTOMERS, getPayingCustomers),
    takeLatest(DashboardTypes.GET_CUSTOMERS_BY_DATE, getCustomersByDate),
    takeLatest(DashboardTypes.GET_EXPRESS_ORDERS, getExpressOrders),

    takeLatest(RolePermissionTypes.GET_ALL_ROLES, getAllRolesPermissions),
    takeLatest(RolePermissionTypes.GET_ALL_MODULES, getAllModules),
    takeLatest(RolePermissionTypes.TRACK_USER_ROLE, trackCurrentUserRole),

    takeLatest('SUBSCRIBE_NOTIFICATION', handleNotification, true),
    takeLatest('UNSUBSCRIBE_NOTIFICATION', handleNotification, false),

    takeEvery(RestaurantTypes.GET_MERCHANT_NOTE, getMerchantNote),

    takeLatest(MapViewTypes.SET_MAP_DATA, toggleMapView),
    takeLatest(CashOutTypes.GET_HISTORY_CASH_OUTS, getHistoryCashOuts),
    takeLatest(CashOutTypes.SYNC_PENDING_CASH_OUTS, syncPendingCashOuts),
    takeEvery(CashOutTypes.CONFIRM_CASH_OUT, confirmCashOut),
    takeEvery(CashOutTypes.CANCEL_CASH_OUT, cancelCashOut),

    takeLatest(AppInboxTypes.SYNC_APP_INBOXES, syncAppInboxes),
    takeLatest(AppInboxTypes.DELETE_APP_INBOX, deleteAppInbox),
    takeEvery(MerchantSettlementTypes.FETCH_PAY_LATER_ORDERS, fetchPayLaterOrders),
    takeLatest(MerchantSettlementTypes.SAVE_MERCHANT_SETTLEMENT, saveMerchantSettlement),
    takeLatest(MerchantSettlementTypes.SYNC_MERCHANT_SETTLEMENTS, syncMerchantSettlements),
    takeLatest(MerchantSettlementTypes.PAID_MERCHANT, paidMerchant),

    takeLatest(ExpressTypes.SYNC_EXPRESS, syncExpress),
    takeLatest(ExpressTypes.GET_COD_REPORT, getCodReport),
    takeLatest(ExpressTypes.GET_EXPRESS_ORDERS_REPORT, getExpressOrdersReport),

    takeLatest(PromotionTypes.GET_PROMOTIONS, getPromotions),
    takeEvery(PromotionTypes.DELETE_PROMOTION, deletePromotion),

    takeLatest(PickUpPromotionTypes.GET_PICK_UP_PROMOTIONS, getPickUpPromotions),
    takeEvery(PickUpPromotionTypes.DELETE_PICK_UP_PROMOTION, deletePickUpPromotion),

    takeLatest(SpecialDealTypes.SYNC_SPECIAL_DEAL, syncSpecialDeal),
    takeLatest(SpecialDealTypes.GET_SPECIAL_DEALS, getSpecialDeals),
    takeEvery(SpecialDealTypes.DELETE_SPECIAL_DEAL, deleteSpecialDeal),

    takeEvery(DeliveryFeeOfferTypes.SAVE_DELIVERY_FEE_OFFER, saveDeliveryFeeOffer),
    takeLatest(DeliveryFeeOfferTypes.GET_DELIVERY_FEE_OFFERS, getDeliveryFeeOffers),
    takeEvery(DeliveryFeeOfferTypes.DELETE_DELIVERY_FEE_OFFER, deleteDeliveryFeeOffer),

    takeLatest(RegionTypes.GET_REGIONS, getRegions),
    takeLatest(RegionTypes.GET_DISTRICTS, getDistricts),
    takeLatest(UnavailableItemTypes.GET_UNAVAILABLE_ITEMS, getUnavailableItem),
    takeLatest(CrossSellItemTypes.GET_CROSS_SELL_ITEMS, getCrossSellItems),

    takeLatest(HasuraOrderTypes.FETCH_ORDERS, fetchOrders),

    takeLatest(HasuraItemTypes.FETCH_ITEMS, fetchItems),
    takeLatest(HasuraSearchItemTypes.SEARCH_ITEMS, searchItems),
    takeLatest(HasuraSearchItemTypes.UPDATE_ALTER_ITEMS, updateAlterItems),

    takeLatest(HasuraOrderTypes.GET_MERCHANT_CATEGORIES, getMerchantCategories),
    takeLatest(HasuraOrderTypes.GET_SALE_REPORTS, getSaleReports),
    takeLatest(HasuraOrderTypes.GET_REFUND_ORDERS, getRefundOrders),
    takeLatest(HasuraOrderTypes.GET_PROMOTION_EXPENSE, getPromotionExpense),
    takeLatest(HasuraOrderTypes.GET_PROMO_CODE_ORDERS, getPromoCodeOrders),

    takeLatest(CartBasedPromotionTypes.GET_CART_BASED_PROMOTIONS, getCartBasedPromotions),

    takeEvery(CartBasedPromotionTypes.SAVE_CART_BASED_PROMOTION, saveCartBasedPromotion),
    takeEvery(CartBasedPromotionTypes.DELETE_CART_BASED_PROMOTION, deleteCartBasedPromotion),

    takeEvery(HasuraDataValidationTypes.GET_ORDERS, getOrders),
    takeEvery(HasuraDataValidationTypes.GET_ITEMS, getItems),
    takeEvery(HasuraDataValidationTypes.REUPLOAD_ORDERS, reuploadOrders),

    takeLatest(MerchandiseCodeTypes.SAVE_MERCHANDISE_CODE, saveMerchandiseCode),
    takeLatest(MerchandiseCodeTypes.GET_MERCHANDISE_CODES, getMerchandiseCodes),

    takeLatest(DriverTransactionTypes.GET_TRANSACTIONS, getDriverTransactions),

    takeLatest(ItemSyncTypes.GET_ITEM_SYNC, getItemSync),
    takeLatest(ItemSyncTypes.SYNC_MERCHANT_ITEMS, syncMerchantItems),
    takeLatest(ItemSyncTypes.SET_LAST_UPDATE, setLastUpdate),

    takeLatest(DelivererOrderTypes.GET_DELIVERER_ORDERS, getDelivererOrders),

    takeLatest(LocationReportTypes.GET_ORDER_LOCATIONS, getLocationReport),

    takeEvery(AppCustomizationTypes.GET_CUSTOMIZATION, getCustomization),

    takeLatest(MerchantCloseRequestTypes.SYNC_PENDING_REQUESTS, syncPendingRequests),

    takeLatest(ServiceAvailabilityTypes.GET_SERVICE_AVAILABILITY, getServiceAvailability),

    takeLatest(FreeCheckoutTypes.SYNC_FREE_CHECKOUT_PROMOTIONS, syncFreeCheckoutPromotions),

    takeLatest(QuantityPromotionTypes.GET_QUANTITY_PROMOTIONS, getQuantityPromotions),
    takeLatest(QuantityPromotionTypes.DELETE_QUANTITY_PROMOTION, deleteQuantityPromotion),
    takeLatest(LuckyDrawWinnerTypes.GET_LUCKY_DRAW_WINNERS, getLuckyDrawWinners)
  ])
}



// WEBPACK FOOTER //
// ./src/sagas/index.js